"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TreeView = _interopRequireDefault(require("@mui/lab/TreeView"));
var _styles = require("../styles");
var _excluded = ["classes", "children"];
var styles = function styles() {
  return {
    root: {
      overflow: 'auto'
    }
  };
};

/**
 * A tree view widget presents a hierarchical list.
 * @done false
 * @updated v6.6.0
 * @versionAdded v6.6.0
 * @examples
 * BasicTreeView
 * TreeViewExample
 * AdvancedTreeView
 */
var TreeView = function TreeView(props) {
  var classes = props.classes,
    children = props.children,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var classOverrides = {
    root: classes.root
  };
  return /*#__PURE__*/_react.default.createElement(_TreeView.default, (0, _extends2.default)({
    classes: classOverrides
  }, rest), children);
};
TreeView.muiName = 'TreeView';
TreeView.propTypes = {
  /**
   * The content of the component. Required to be TreeItems.
   */
  children: _propTypes.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * @ignore
   * The default icon used to collapse the node.
   */
  defaultCollapseIcon: _propTypes.default.node,
  /**
   * @ignore
   * The default icon displayed next to a end node. This is applied to all
   * tree nodes and can be overridden by the TreeItem `icon` prop.
   */
  defaultEndIcon: _propTypes.default.node,
  /**
   * Expanded node ids. (Uncontrolled)
   */
  defaultExpanded: _propTypes.default.arrayOf(_propTypes.default.string),
  /**
   * @ignore
   * The default icon used to expand the node.
   */
  defaultExpandIcon: _propTypes.default.node,
  /**
   * @ignore
   * The default icon displayed next to a parent node. This is applied to all
   * parent nodes and can be overridden by the TreeItem `icon` prop.
   */
  defaultParentIcon: _propTypes.default.node,
  /**
   * Initial Selected nodeId (Uncontrolled).
   * Used only when there is no selected nodeId
   */
  defaultSelected: _propTypes.default.string,
  /**
   * @ignore
   * If `true`, will allow focus on disabled items
   */
  disableItemsFocusable: _propTypes.default.bool,
  /**
   * @ignore
   * If `true` selection is disabled.
   */
  disableSelection: _propTypes.default.bool,
  /**
   * Expanded node ids. (Controlled)
   */
  expanded: _propTypes.default.arrayOf(_propTypes.default.string),
  /**
   * @ignore
   * If true `ctrl` and `shift` will trigger multiselect.
   */
  multiSelect: _propTypes.default.bool,
  /**
   * @ignore
   * @param {object} event The event source of the callback
   * @param {string} value Value of the focused node.
   */
  onNodeFocus: _propTypes.default.func,
  /**
   * Callback fired when tree items are selected/unselected.
   *
   * @param {object} event The event source of the callback
   * @param {string} value Value of the selected node.
   */
  onNodeSelect: _propTypes.default.func,
  /**
   * Callback fired when tree items are expanded/collapsed.
   *
   * @param {object} event The event source of the callback.
   * @param {array} nodeIds The ids of the expanded nodes.
   */
  onNodeToggle: _propTypes.default.func,
  /**
   * Selected nodeId (Controlled).
   */
  selected: _propTypes.default.string
};
TreeView.defaultProps = {
  defaultExpanded: []
};
var _default = exports.default = (0, _styles.withStyles)(styles)(TreeView);